
const digest = 'd84b3d455dd511160dd9999adb143284995976b736f71b23c948fcef5f24e6e6';
const classes = {"item":"_item_3fu4l_1","patient":"_patient_3fu4l_8","patientImage":"_patientImage_3fu4l_16","patientData":"_patientData_3fu4l_21","title":"_title_3fu4l_26","text":"_text_3fu4l_31","contentItem":"_contentItem_3fu4l_35","lightGrey":"_lightGrey_3fu4l_42","extra":"_extra_3fu4l_47","name":"_name_3fu4l_51","content":"_content_3fu4l_35","titleText":"_titleText_3fu4l_82","titleMore":"_titleMore_3fu4l_85","red":"_red_3fu4l_99","orange":"_orange_3fu4l_107","green":"_green_3fu4l_111","controls":"_controls_3fu4l_115","link":"_link_3fu4l_126"};
const css = `._item_3fu4l_1 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._item_3fu4l_1 ._patient_3fu4l_8 {
  display: flex;
  border-right: 1px solid #eaedf3;
  padding: 12px 24px;
  gap: 10px;
  min-width: 350px;
  max-width: 350px;
}
._item_3fu4l_1 ._patient_3fu4l_8 ._patientImage_3fu4l_16 {
  width: 36px;
  height: 36px;
  border-radius: 100%;
}
._item_3fu4l_1 ._patient_3fu4l_8 ._patientData_3fu4l_21 {
  display: flex;
  gap: 12px;
  flex-direction: column;
}
._item_3fu4l_1 ._patient_3fu4l_8 ._patientData_3fu4l_21 ._title_3fu4l_26 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
._item_3fu4l_1 ._patient_3fu4l_8 ._patientData_3fu4l_21 ._text_3fu4l_31 {
  color: #3e3f42;
  font-size: 14px;
}
._item_3fu4l_1 ._patient_3fu4l_8 ._patientData_3fu4l_21 ._contentItem_3fu4l_35 {
  font-size: 14px;
  color: #000000;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
._item_3fu4l_1 ._patient_3fu4l_8 ._patientData_3fu4l_21 ._contentItem_3fu4l_35 ._lightGrey_3fu4l_42 {
  color: #9ea0a5;
  font-weight: 400;
  min-width: 140px;
}
._item_3fu4l_1 ._patient_3fu4l_8 ._extra_3fu4l_47 {
  display: flex;
  gap: 40px;
}
._item_3fu4l_1 ._patient_3fu4l_8 ._extra_3fu4l_47 ._name_3fu4l_51 {
  font-size: 14px;
  color: #000000;
  display: flex;
  align-items: center;
  gap: 5px;
}
._item_3fu4l_1 ._patient_3fu4l_8 ._extra_3fu4l_47 ._name_3fu4l_51 span {
  color: #9ea0a5;
  font-weight: 400;
}
._item_3fu4l_1 ._content_3fu4l_35 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 24px;
  gap: 7px;
}
._item_3fu4l_1 ._content_3fu4l_35 ._extra_3fu4l_47 {
  display: flex;
  gap: 40px;
}
._item_3fu4l_1 ._content_3fu4l_35 ._title_3fu4l_26 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px;
}
._item_3fu4l_1 ._content_3fu4l_35 ._titleText_3fu4l_82 {
  word-break: break-word;
}
._item_3fu4l_1 ._content_3fu4l_35 ._titleMore_3fu4l_85 {
  flex-shrink: 0;
}
._item_3fu4l_1 ._content_3fu4l_35 ._name_3fu4l_51 {
  font-size: 14px;
  color: #000000;
  display: flex;
  align-items: center;
  gap: 5px;
}
._item_3fu4l_1 ._content_3fu4l_35 ._name_3fu4l_51 span {
  color: #9ea0a5;
  font-weight: 400;
}
._item_3fu4l_1 ._content_3fu4l_35 ._red_3fu4l_99 {
  color: #c53127;
  font-weight: 600;
}
._item_3fu4l_1 ._content_3fu4l_35 ._red_3fu4l_99 span {
  color: #c53127;
  font-weight: 600;
}
._item_3fu4l_1 ._content_3fu4l_35 ._orange_3fu4l_107 span {
  color: #f18200;
  font-weight: 600;
}
._item_3fu4l_1 ._content_3fu4l_35 ._green_3fu4l_111 span {
  color: #619622;
  font-weight: 600;
}
._item_3fu4l_1 ._controls_3fu4l_115 {
  min-width: 310px;
  max-width: 310px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  gap: 12px;
}
._item_3fu4l_1 ._controls_3fu4l_115 ._link_3fu4l_126 {
  text-align: center;
}

._red_3fu4l_99 {
  background: #f8dadb;
}

._orange_3fu4l_107 {
  background: #fcf0e0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  